const SLUG_RE = /^[a-z0-9]+(-[a-z0-9]+)*$/;
const SLUG_MIN_LEN = 3;
const SLUG_MAX_LEN = 50;

/**
 * Mirrors DB rules for `link_in_bio.slug` (lowercase segment + hyphens).
 * @param {string | undefined | null} slug
 */
export function isLinkInBioSlugFormatValid(slug) {
  const s = String(slug || "")
    .trim()
    .toLowerCase();
  if (s.length < SLUG_MIN_LEN || s.length > SLUG_MAX_LEN) {
    return false;
  }
  return SLUG_RE.test(s);
}
